import { render, staticRenderFns } from "./CouponStockCard.vue?vue&type=template&id=1c75da48&scoped=true&"
import script from "./CouponStockCard.vue?vue&type=script&lang=js&"
export * from "./CouponStockCard.vue?vue&type=script&lang=js&"
import style0 from "./CouponStockCard.vue?vue&type=style&index=0&id=1c75da48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c75da48",
  null
  
)

export default component.exports